<template>
	<div class="text-center">
	    <v-menu  :close-on-content-click="true" >
	      	<template v-slot:activator="{ on: menu, attrs }">
	        	<v-tooltip bottom>
	         		<template v-slot:activator="{ on: tooltip }">
			            <v-btn
			              	dark
			              	:x-large="isLarge"
			              	elevation="20"
			            	:x-small="isXSmall"
			            	:small="isSmall"
			            	:icon="isIconBtn"
			              	:color="colorField || 'transparent'"
			              	v-bind="attrs"
			              	v-on="{ ...tooltip, ...menu }"
			              	:fab="isFab" 		
			              	:block="isBlock"	              	
			              	:height="isCounter?'55px':''"
			            >
			            	<v-row no-gutters>
			            		<v-col :cols="isCounter?12:3">
		              				<v-icon  :large="isLarge" v-show="isIcon" class="mr-2">mdi-tag</v-icon>
			            			
			            		</v-col>
			            		<v-col :cols="isCounter?12:9">
		              				<span v-show="isLabel " > {{ inputField[keyField] ? renderSelecteds : $ml.get('tag')  }} </span>			            			
			            		</v-col>
			            	</v-row>
	              			<v-input  height="2" v-show="isInput" :messages="renderSelecteds">
	              				<span style="font-size: 10px"> {{ $ml.get('tag') }} </span>
					        </v-input>
	            		</v-btn>

	          		</template>
	          		<span>{{$ml.get("tag") }} : {{renderSelecteds}}</span>
	        	</v-tooltip>
	      	</template>
	      	<v-list dense>
	      		<v-list-item :disabled="true" v-show="renderList.length == 0">
	      			<v-list-item-title>{{ this.$ml.get("required_select_analytic")}} </v-list-item-title>
	      		</v-list-item>
	      		<v-list-item-group
			        :multiple="isMultiple"
			        v-model="inputField[keyField]"
			        color="primary"
			        @change="AutoSetInField($event)"
			    >

		        	<v-list-item
			          	v-for="(item, index) in renderList"
			          	:key="index"
			          	:value="valueField ? item[valueField] : item"
		        	>
		          		<v-list-item-title>{{ item.name }}</v-list-item-title>
		        	</v-list-item>
	        	</v-list-item-group>
	      	</v-list>
	    </v-menu>
  	</div>

</template>
<script type="text/javascript">
	export default{
		name : "MenuTagCounter",
		props : ["inputField", "keyField", "fieldLink",  "isLabel", "isXSmall", "isSmall", "isFab", "isIcon", "colorField", "isMultiple", "isIconBtn", "AutoSetField", "AutoValueField", "isBlock", "isInput", "isLarge", "valueField", "isCounter"],
		data : ()=>({
			loading:false,
			menu:false,						
		}),
		mounted(){
			if (!this.$store.getters["Tags/getIsLoadedData"]) {
				this.$store.dispatch("Tags/getListData")
			}
			if (!this.$store.getters["Tags/getIsLoadedSmartEvent"]) {
				const temp = this.$SmartEvent.get(null, "list")				
				if (temp && temp.length > 0) {					
					this.$store.commit("Tags/setListSmartEvent", temp)					
				}
			}
		},
		computed:{
			renderList(){								
				return this.fieldLink && !["", "analytics"].includes(this.fieldLink)? this.$store.getters["Tags/getBySelect"](this.fieldLink)?.list : [];
			},
			renderSelecteds(){
				return (this.isMultiple? this.inputField[this.keyField].map(x=> x.name) : (this.valueField? this.inputField[this.keyField] : this.inputField[this.keyField]?.name)) || this.$ml.get("none_selected") 
			}
		},		
		methods:{
			AutoSetInField(item){
				if (this.AutoSetField && item) {
					if (this.AutoValueField && !this.valueField) {
						this.inputField[this.AutoSetField]=item?.[this.AutoValueField] || undefined;
					}else{
						this.inputField[this.AutoSetField]=item;
					}
				}

			}
		}
	}
</script>